import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SocialMediaIntegration = () => {
  const [activeTab, setActiveTab] = useState('facebook');

  const socialPlatforms = [
    {
      id: 'facebook',
      name: 'Facebook',
      icon: 'Facebook',
      handle: '@LeoClubColombo',
      followers: '2.5K',
      description: 'Daily updates, event photos, and community stories',
      color: 'bg-blue-600',
      url: 'https://facebook.com/leoclubcolombo'
    },
    {
      id: 'instagram',
      name: 'Instagram',
      icon: 'Instagram',
      handle: '@leoclubcolombo',
      followers: '3.2K',
      description: 'Behind-the-scenes content and visual storytelling',
      color: 'bg-pink-600',
      url: 'https://instagram.com/leoclubcolombo'
    },
    {
      id: 'linkedin',
      name: 'LinkedIn',
      icon: 'Linkedin',
      handle: 'Leo Club of Colombo Circle',
      followers: '1.8K',
      description: 'Professional updates and leadership development content',
      color: 'bg-blue-700',
      url: 'https://linkedin.com/company/leo-club-colombo'
    },
    {
      id: 'twitter',
      name: 'Twitter',
      icon: 'Twitter',
      handle: '@LeoClubColombo',
      followers: '1.2K',
      description: 'Real-time updates and community engagement',
      color: 'bg-blue-500',
      url: 'https://twitter.com/leoclubcolombo'
    }
  ];

  const recentPosts = {
    facebook: [
      {
        id: 1,
        content: "🌟 Amazing turnout at yesterday\'s community cleanup drive! Over 50 volunteers joined us to make Galle Face Green cleaner and greener. Thank you to everyone who participated!",
        image: "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=400&h=300&fit=crop",
        likes: 127,
        comments: 23,
        shares: 15,
        timestamp: "2 hours ago"
      },
      {
        id: 2,
        content: "📚 Our literacy program reached another milestone - 200 children now have access to quality educational resources. Education is the foundation of a better tomorrow! #LeoClubColombo #Education",
        likes: 89,
        comments: 12,
        shares: 8,
        timestamp: "1 day ago"
      },
      {
        id: 3,
        content: "🤝 Proud to announce our new partnership with Colombo Municipal Council for the 'Clean City Initiative'. Together, we're making Colombo a model city for sustainable living!",
        likes: 156,
        comments: 31,
        shares: 22,
        timestamp: "3 days ago"
      }
    ],
    instagram: [
      {
        id: 1,
        content: "Behind the scenes of our food distribution drive 📸 Every smile makes the early morning worth it! #CommunityService #LeoClub",
        image: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=400&h=400&fit=crop",
        likes: 234,
        comments: 18,
        timestamp: "4 hours ago"
      },
      {
        id: 2,
        content: "Leadership development workshop in action! 💪 Our members are not just serving the community, they're growing as leaders. #Leadership #Growth",
        image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=400&fit=crop",
        likes: 178,
        comments: 25,
        timestamp: "2 days ago"
      }
    ],
    linkedin: [
      {
        id: 1,
        content: "Leo Club of Colombo Circle is proud to announce the successful completion of our Q4 leadership development program. 25 young professionals enhanced their skills in project management, team leadership, and community engagement.",
        likes: 67,
        comments: 8,
        shares: 12,
        timestamp: "1 day ago"
      },
      {
        id: 2,
        content: "Seeking corporate partners for our upcoming \'Digital Literacy for All\' initiative. This program aims to bridge the digital divide by providing technology training to underserved communities in Colombo.",
        likes: 45,
        comments: 15,
        shares: 18,
        timestamp: "4 days ago"
      }
    ],
    twitter: [
      {
        id: 1,
        content: "🚨 Emergency response team activated for flood relief in Kelaniya. Our volunteers are on the ground providing immediate assistance. #FloodRelief #CommunitySupport",
        likes: 89,
        retweets: 34,
        comments: 12,
        timestamp: "6 hours ago"
      },
      {
        id: 2,
        content: "Join us this Saturday for our monthly beach cleanup at Mount Lavinia! 🏖️ Registration link in bio. Let's keep our coastline beautiful! #BeachCleanup #Environment",
        likes: 56,
        retweets: 23,
        comments: 8,
        timestamp: "1 day ago"
      }
    ]
  };

  const newsletterStats = {
    subscribers: "1,247",
    openRate: "68%",
    lastSent: "3 days ago",
    nextIssue: "January 28, 2025"
  };

  const handleSocialClick = (url) => {
    window.open(url, '_blank');
  };

  const handleNewsletterSignup = (e) => {
    e.preventDefault();
    // Handle newsletter signup
    alert('Thank you for subscribing to our newsletter!');
  };

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Stay Connected
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Follow our journey and join the conversation across all platforms
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          {/* Social Media Platforms */}
          <div className="lg:col-span-2">
            <div className="bg-card rounded-xl card-shadow overflow-hidden">
              {/* Platform Tabs */}
              <div className="border-b border-border">
                <div className="flex overflow-x-auto">
                  {socialPlatforms.map((platform) => (
                    <button
                      key={platform.id}
                      onClick={() => setActiveTab(platform.id)}
                      className={`flex items-center gap-3 px-6 py-4 text-sm font-medium whitespace-nowrap transition-smooth ${
                        activeTab === platform.id
                          ? 'border-b-2 border-primary text-primary bg-primary/5' :'text-muted-foreground hover:text-foreground'
                      }`}
                    >
                      <Icon name={platform.icon} size={20} />
                      <span>{platform.name}</span>
                      <span className="bg-muted text-muted-foreground px-2 py-1 rounded-full text-xs">
                        {platform.followers}
                      </span>
                    </button>
                  ))}
                </div>
              </div>

              {/* Platform Content */}
              <div className="p-6">
                {socialPlatforms.map((platform) => (
                  activeTab === platform.id && (
                    <div key={platform.id} className="space-y-6">
                      {/* Platform Header */}
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                          <div className={`w-12 h-12 ${platform.color} rounded-full flex items-center justify-center`}>
                            <Icon name={platform.icon} size={24} className="text-white" />
                          </div>
                          <div>
                            <h3 className="text-lg font-semibold text-card-foreground">
                              {platform.handle}
                            </h3>
                            <p className="text-sm text-muted-foreground">
                              {platform.description}
                            </p>
                          </div>
                        </div>
                        <Button
                          variant="outline"
                          iconName="ExternalLink"
                          iconPosition="right"
                          onClick={() => handleSocialClick(platform.url)}
                        >
                          Follow
                        </Button>
                      </div>

                      {/* Recent Posts */}
                      <div className="space-y-4">
                        <h4 className="font-semibold text-card-foreground">Recent Posts</h4>
                        {recentPosts[platform.id]?.map((post) => (
                          <div key={post.id} className="border border-border rounded-lg p-4">
                            <div className="flex gap-3">
                              <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                                <Icon name={platform.icon} size={16} className="text-primary" />
                              </div>
                              <div className="flex-1">
                                <p className="text-card-foreground mb-3">
                                  {post.content}
                                </p>
                                {post.image && (
                                  <div className="mb-3 rounded-lg overflow-hidden">
                                    <img
                                      src={post.image}
                                      alt="Post content"
                                      className="w-full h-48 object-cover"
                                    />
                                  </div>
                                )}
                                <div className="flex items-center justify-between text-sm text-muted-foreground">
                                  <span>{post.timestamp}</span>
                                  <div className="flex items-center gap-4">
                                    {post.likes && (
                                      <span className="flex items-center gap-1">
                                        <Icon name="Heart" size={14} />
                                        {post.likes}
                                      </span>
                                    )}
                                    {post.comments && (
                                      <span className="flex items-center gap-1">
                                        <Icon name="MessageCircle" size={14} />
                                        {post.comments}
                                      </span>
                                    )}
                                    {post.shares && (
                                      <span className="flex items-center gap-1">
                                        <Icon name="Share" size={14} />
                                        {post.shares}
                                      </span>
                                    )}
                                    {post.retweets && (
                                      <span className="flex items-center gap-1">
                                        <Icon name="Repeat" size={14} />
                                        {post.retweets}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )
                ))}
              </div>
            </div>
          </div>

          {/* Newsletter Signup */}
          <div className="space-y-8">
            <div className="bg-card rounded-xl p-8 card-shadow">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon name="Mail" size={24} className="text-primary" />
                </div>
                <h3 className="text-xl font-semibold text-card-foreground mb-2">
                  Newsletter
                </h3>
                <p className="text-sm text-muted-foreground">
                  Get monthly updates on our activities and impact
                </p>
              </div>

              <div className="grid grid-cols-2 gap-4 mb-6 text-center">
                <div>
                  <div className="text-2xl font-bold text-primary">{newsletterStats.subscribers}</div>
                  <div className="text-xs text-muted-foreground">Subscribers</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-accent">{newsletterStats.openRate}</div>
                  <div className="text-xs text-muted-foreground">Open Rate</div>
                </div>
              </div>

              <form onSubmit={handleNewsletterSignup} className="space-y-4">
                <div>
                  <input
                    type="email"
                    placeholder="Enter your email"
                    required
                    className="w-full px-4 py-3 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-card-foreground mb-2">
                    Frequency
                  </label>
                  <select className="w-full px-4 py-3 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent text-sm">
                    <option value="monthly">Monthly Digest</option>
                    <option value="weekly">Weekly Updates</option>
                    <option value="events">Events Only</option>
                  </select>
                </div>

                <div className="space-y-2">
                  <label className="block text-sm font-medium text-card-foreground">
                    Content Preferences
                  </label>
                  {[
                    'Project Updates',
                    'Event Announcements',
                    'Member Spotlights',
                    'Leadership Tips'
                  ].map((preference) => (
                    <label key={preference} className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        defaultChecked
                        className="w-4 h-4 text-primary border-border rounded focus:ring-primary"
                      />
                      <span className="text-sm text-card-foreground">{preference}</span>
                    </label>
                  ))}
                </div>

                <Button
                  type="submit"
                  variant="default"
                  iconName="Send"
                  iconPosition="left"
                  fullWidth
                >
                  Subscribe
                </Button>
              </form>

              <div className="mt-4 text-xs text-muted-foreground text-center">
                <p>Last sent: {newsletterStats.lastSent}</p>
                <p>Next issue: {newsletterStats.nextIssue}</p>
              </div>
            </div>

            {/* Quick Social Links */}
            <div className="bg-card rounded-xl p-6 card-shadow">
              <h3 className="text-lg font-semibold text-card-foreground mb-4 text-center">
                Follow Us
              </h3>
              <div className="grid grid-cols-2 gap-3">
                {socialPlatforms.map((platform) => (
                  <button
                    key={platform.id}
                    onClick={() => handleSocialClick(platform.url)}
                    className={`${platform.color} text-white p-3 rounded-lg hover:opacity-90 transition-smooth flex items-center justify-center gap-2`}
                  >
                    <Icon name={platform.icon} size={18} />
                    <span className="text-sm font-medium">{platform.name}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* Contact Hours */}
            <div className="bg-card rounded-xl p-6 card-shadow">
              <h3 className="text-lg font-semibold text-card-foreground mb-4 flex items-center gap-2">
                <Icon name="Clock" size={20} className="text-primary" />
                Office Hours
              </h3>
              <div className="space-y-3 text-sm">
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Monday - Friday</span>
                  <span className="text-card-foreground font-medium">9:00 AM - 6:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Saturday</span>
                  <span className="text-card-foreground font-medium">10:00 AM - 4:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Sunday</span>
                  <span className="text-card-foreground font-medium">Closed</span>
                </div>
                <div className="pt-3 border-t border-border">
                  <div className="flex items-center gap-2 text-accent">
                    <Icon name="Zap" size={16} />
                    <span className="text-sm font-medium">Emergency: 24/7</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Executive Board Contact */}
        <div className="bg-card rounded-xl p-8 card-shadow">
          <h3 className="text-2xl font-semibold text-card-foreground mb-8 text-center">
            Executive Board Contact
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              {
                role: "President",
                name: "Arjun Perera",
                email: "president@leoclubcolombo.lk",
                phone: "+94 77 111 2222",
                responsibilities: "Overall leadership, strategic planning, external relations"
              },
              {
                role: "Vice President",
                name: "Priya Jayawardena",
                email: "vp@leoclubcolombo.lk",
                phone: "+94 77 222 3333",
                responsibilities: "Operations management, member coordination"
              },
              {
                role: "Secretary",
                name: "Kasun Silva",
                email: "secretary@leoclubcolombo.lk",
                phone: "+94 77 333 4444",
                responsibilities: "Meeting minutes, documentation, communications"
              },
              {
                role: "Treasurer",
                name: "Nisha Fernando",
                email: "treasurer@leoclubcolombo.lk",
                phone: "+94 77 444 5555",
                responsibilities: "Financial management, budget planning, fundraising"
              }
            ].map((officer) => (
              <div key={officer.role} className="text-center">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon name="User" size={24} className="text-primary" />
                </div>
                <h4 className="font-semibold text-card-foreground mb-1">{officer.role}</h4>
                <p className="text-sm text-muted-foreground mb-3">{officer.name}</p>
                <div className="space-y-2">
                  <button
                    onClick={() => window.open(`mailto:${officer.email}`, '_blank')}
                    className="flex items-center gap-2 text-xs text-primary hover:text-primary/80 transition-smooth mx-auto"
                  >
                    <Icon name="Mail" size={14} />
                    Email
                  </button>
                  <button
                    onClick={() => window.open(`tel:${officer.phone}`, '_self')}
                    className="flex items-center gap-2 text-xs text-primary hover:text-primary/80 transition-smooth mx-auto"
                  >
                    <Icon name="Phone" size={14} />
                    Call
                  </button>
                </div>
                <p className="text-xs text-muted-foreground mt-3 leading-relaxed">
                  {officer.responsibilities}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialMediaIntegration;